export default "__VITE_ASSET__D3553z6S__"